import React from 'react';
import { cn } from 'app/utils/utils';

const Typography = ({ 
  component: Component = 'div', 
  children, 
  className, 
  ellipsis, 
  textTransform, 
  ...props 
}) => {
  return (
    <Component
      className={cn(
        ellipsis && "truncate block",
        textTransform && `uppercase`,
        className
      )}
      style={{
        textTransform: textTransform || 'none',
        ...props.style
      }}
      {...props}
    >
      {children}
    </Component>
  );
};

export const H1 = ({ className, ...props }) => (
  <Typography component="h1" className={cn("text-[28px] font-medium leading-normal m-0", className)} {...props} />
);

export const H2 = ({ className, ...props }) => (
  <Typography component="h2" className={cn("text-[24px] font-medium leading-normal m-0", className)} {...props} />
);

export const H3 = ({ className, ...props }) => (
  <Typography component="h3" className={cn("text-[18px] font-medium leading-normal m-0", className)} {...props} />
);

export const H4 = ({ className, ...props }) => (
  <Typography component="h4" className={cn("text-[16px] font-medium leading-normal m-0", className)} {...props} />
);

export const H5 = ({ className, ...props }) => (
  <Typography component="h5" className={cn("text-[14px] font-medium leading-normal m-0", className)} {...props} />
);

export const H6 = ({ className, ...props }) => (
  <Typography component="h6" className={cn("text-[13px] font-medium leading-normal m-0", className)} {...props} />
);

export const Paragraph = ({ className, ...props }) => (
  <Typography component="p" className={cn("text-[14px] m-0", className)} {...props} />
);

export const Small = ({ className, ...props }) => (
  <Typography component="small" className={cn("text-[12px] font-medium leading-normal", className)} {...props} />
);

export const Span = ({ className, ...props }) => (
  <Typography component="span" className={cn("leading-normal", className)} {...props} />
);

export const Tiny = ({ className, ...props }) => (
  <Typography component="small" className={cn("text-[10px] leading-normal", className)} {...props} />
);
